import script from "./PageChildTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./PageChildTemplate.vue?vue&type=script&setup=true&lang=js"

import "./PageChildTemplate.vue?vue&type=style&index=0&id=2d26bac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d26bac0"]])

export default __exports__